import React from "react";
import {
  FormDataConsumer,
  ReferenceInput,
  AutocompleteInput,
  TextInput,
  required
} from "react-admin";

const CurrentInsurerInput = props => (
  <FormDataConsumer>
    {({ formData }) => {
      const isFinalised =
        Number(formData?.statusId) === 231;

      if (!isFinalised) {
        return (
          <TextInput
            {...props}
            source="currentInsurerId"
            label="Current Insurer"
            fullWidth
            disabled
            value=""
          />
        );
      }

      return (
        <ReferenceInput
          {...props}
          source="currentInsurerId"
          reference="insurers"
          perPage={1000}
          sort={{ field: "name", order: "ASC" }}
          enableGetChoices={({ q }) => !!q && q.length >= 2}
        >
          <AutocompleteInput
            optionText="name"
            debounce={1000}
            filterToQuery={q => ({ q })}
            validate={[required()]}
          />
        </ReferenceInput>
      );
    }}
  </FormDataConsumer>
);

export default CurrentInsurerInput;